import React, { useMemo, useState } from "react";
import { ButtonSecondary } from "../globals";
import { MainBlock, MiniBlock } from "../common/Buttons";
import {
  antdMessageError,
  antdMessageSuccess,
  phonenumberValid,
} from "../../helpers/Utils";
import ModalSpecial from "../Layout/Modals/ModalSpecial";
import Spinner from "../common/Spinner";
import { Divs } from "../common/StyledComponents";
import PreviewComment from "../common/GlobalModals/Orders/editModal/previewComment";
import OrderRowsComponent from "../common/GlobalModals/Orders/editModal/order_row/order_rows";
import { GrClose, GrEdit } from "react-icons/gr";
import ShippingAddressComponent from "../common/GlobalModals/Orders/editModal/shippingAddress";
import BillingAddressComponent from "../common/GlobalModals/Orders/editModal/billingAddress";
import AntdConfirm from "../../helpers/AntdConfirm";
import { useMutation, useQuery, useQueryClient } from "react-query";
import Axios from "axios";
import ModalSmsSending from "../Layout/Modals/ModalSmsSending";
import ModalCreateComment from "../Layout/Modals/ModalCreateComment";

const fetchLostCart = async ({ queryKey }) => {
  const [key, { lost_cart_id }] = queryKey;
  const response = await Axios.get(`/api/v1/${key}/${lost_cart_id}`);
  return response.data;
};
const ModalLostCart = ({
  lost_cart_id,
  close,
  comment_states,
  mutationFinishOrder,
  mutationDelete,
}) => {
  const { error, status, data } = useQuery({
    queryKey: ["lost_carts", { lost_cart_id }],
    queryFn: fetchLostCart,
  });

  return (
    <ModalSpecial
      text={
        status !== "success" ? (
          "-"
        ) : (
          <span className="d-flex align-items-center justify-content-between w-100">
            <div>
              <span className="font-bold text-xl text-black">Cart</span>
              <span className="font-bold text-xl">#</span>
              <span className="font-bold text-xl text-black">
                {lost_cart_id}
              </span>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 4,
              }}
            >
              <ButtonSecondary
                outline={true}
                onClick={() =>
                  AntdConfirm({
                    onOk: () => {
                      mutationDelete.mutate(lost_cart_id);
                    },
                  })
                }
              >
                Discard
              </ButtonSecondary>
              <ButtonSecondary
                onClick={() =>
                  AntdConfirm({
                    onOk: () => {
                      mutationFinishOrder.mutate(lost_cart_id);
                    },
                  })
                }
              >
                Finish cart to order
              </ButtonSecondary>
            </div>
          </span>
        )
      }
      handleSave={() => {}}
      onClose={() => {
        close();
      }}
    >
      {status == "loading" ? (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Spinner />
        </div>
      ) : status == "error" ? (
        <p>{JSON.stringify(error)}</p>
      ) : (
        <ModalLostCartContent comment_states={comment_states} record={data} />
      )}
    </ModalSpecial>
  );
};

const ModalLostCartContent = ({ comment_states, record }) => {
  const [collapse, setCollapse] = useState({
    order_information: true,
    information_goods: true,
  });

  const commentStates = useMemo(() => {
    return (
      comment_states.map((comment_state) => ({
        label: comment_state.name,
        value: comment_state.id,
        comment_type: comment_state.comment_type,
      })) || []
    );
  }, [comment_states]);

  const utils = useQueryClient();

  const mutationAddress = useMutation({
    mutationFn: (body) => {
      return Axios.put(`/api/v1/lost_carts/${record.id}`, {
        lost_cart: body,
      }).then((res) => res.data);
    },
    onSuccess: async () => {
      await utils.invalidateQueries([
        "lost_carts",
        { lost_cart_id: record.id },
      ]);
      antdMessageSuccess();
      if (collapse.shippingAdr_action_edit) {
        onCollapse("shippingAdr_action_edit");
      }
      if (collapse.billingAdr_action_edit) {
        onCollapse("billingAdr_action_edit");
      }
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const onCollapse = (item) => {
    setCollapse((prev) => {
      let obj = { ...prev };

      obj[item] = !obj[item];
      return obj;
    });
  };

  return (
    <div className="row">
      <div className="col-6">
        <Divs className="container-title-block">
          <MainBlock
            color={"#ffa800"}
            action={collapse.order_information}
            onChange={() => onCollapse("order_information")}
          >
            Ordering information
          </MainBlock>
          {collapse.order_information && (
            <div className="col-12 row my-3" style={{ margin: 0 }}>
              <Divs className="col-6" style={{ width: "50%" }}>
                <div className="d-flex justify-content-between font-weight-bold mb-3">
                  <span>Delivery information</span>
                  <div
                    className="d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      onCollapse("shippingAdr_action_edit");
                    }}
                  >
                    {collapse.shippingAdr_action_edit ? (
                      <GrClose title="Cancel" />
                    ) : (
                      <GrEdit title="Edit" />
                    )}
                  </div>
                </div>
                <ShippingAddressComponent
                  module_name={null}
                  shippingAdr_action_edit={collapse.shippingAdr_action_edit}
                  shipping_address={record.shipping_address}
                  updateOrderAddress={(type, value) => {
                    delete value.country;
                    mutationAddress.mutate({
                      [`${type}_address_attributes`]: value,
                    });
                  }}
                  customer={record.customer}
                />
              </Divs>
              <Divs
                className="col-6"
                style={{
                  width: "50%",
                  borderLeft: "1px solid #e3e3e3",
                }}
              >
                <div className="d-flex justify-content-between font-weight-bold mb-3">
                  <span>Payer information</span>
                  <div
                    className="d-flex align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => onCollapse("billingAdr_action_edit")}
                  >
                    {collapse.billingAdr_action_edit ? (
                      <GrClose title="Cancel" />
                    ) : (
                      <GrEdit title="Edit" />
                    )}
                  </div>
                </div>
                <BillingAddressComponent
                  billingAdr_action_edit={collapse.billingAdr_action_edit}
                  billing_address={record.billing_address}
                  postToRivile={false}
                  orderId={null}
                  onToggle={() => onCollapse("billingAdr_action_edit")}
                  customAction={(value) => {
                    mutationAddress.mutate(value);
                  }}
                  customer={record.customer}
                />
              </Divs>
            </div>
          )}

          <MainBlock
            color={"#ffcc69"}
            action={collapse.information_goods}
            onChange={() => onCollapse("information_goods")}
          >
            Goods
          </MainBlock>
          {collapse.information_goods && (
            <OrderRowsComponent
              order_rows={record.order_rows}
              order_id={null}
              order_shop={{}}
            />
          )}
        </Divs>
      </div>
      <div className="col-6">
        <Divs className="bg-silver">
          <MainBlock
            color={"#008aff"}
            action={collapse.comments}
            onChange={() => onCollapse("comments")}
          >
            Comments
          </MainBlock>
          {collapse.comments && (
            <div className="mb-4 mt-2">
              <MiniBlock
                color={"#7ebff7"}
                action={collapse.ka_comment}
                onChange={() => onCollapse("ka_comment")}
              >
                KA comments
              </MiniBlock>
              {collapse.ka_comment && (
                <div className="col-12 pb-3">
                  <ModalCreateComment
                    type="comment_ka"
                    record_type="lost_carts"
                    record_id={record.id}
                    comment_states={commentStates}
                  />
                  <PreviewComment
                    comments={record.comments}
                    type="comment_ka"
                  />
                </div>
              )}
              <MiniBlock
                color={"#7ebff7"}
                action={collapse.management_comment}
                onChange={() => onCollapse("management_comment")}
              >
                Management comments
              </MiniBlock>
              {collapse.management_comment && (
                <div className="col-12 pb-3">
                  <ModalCreateComment
                    type="comment_management"
                    record_type="lost_carts"
                    record_id={record.id}
                    comment_states={commentStates}
                  />
                  <PreviewComment
                    comments={record.comments}
                    type="comment_management"
                  />
                </div>
              )}
            </div>
          )}
        </Divs>
        <Divs>
          <MainBlock
            color={"#adcb35"}
            action={collapse.sms_sending}
            onChange={() => onCollapse("sms_sending")}
          >
            Send SMS to number{" "}
            {
              <span
                className={
                  phonenumberValid(record.billing_address.phone)
                    ? ""
                    : "text-danger"
                }
              >
                {record.billing_address.phone}
              </span>
            }
          </MainBlock>
          {collapse.sms_sending && (
            <ModalSmsSending
              data={record.sms_sendings}
              phoneNumber={record.billing_address.phone}
              shipments={[]}
              country_id={record.shipping_address.country_id}
              lost_cart_id={record.id}
            />
          )}
        </Divs>
      </div>
    </div>
  );
};

export default ModalLostCart;
